"use client";

import React from "react";
import { ChevronRight, Play, Clock, Users, Sun, DollarSign } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const services = [{
  index: "01",
  title: "Harbour Junk Charter",
  description: "Private junk on Victoria Harbour — sunset, city views, catered. The ultimate HK welcome or reward.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/WhatsApp-Image-2026-05-24-at-08.02.11-scaled.png",
  duration: "3-4 hrs",
  capacity: "10-80 pax",
  timeOfDay: "Afternoon / sunset",
  pricePerHead: "From $850 HKD",
  badge: "Most booked",
  tags: "team building, large, short, boating"
}, {
  index: "02",
  title: "Hong Kong Orientation: The Essential Tour",
  description: "Designed for first-time visitors and new regional hires. The Peak for the skyline, a Star Ferry crossing, a walk through Central's colonial and modern contrasts, Wong Tai Sin temple, and a local lunch in Mong Kok. Covers geography, history, and culture — guests arrive at their first meeting actually knowing the city.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/20190604_120313-scaled.png",
  duration: "2-3 hrs",
  capacity: "1-20 pax",
  timeOfDay: "Half day / Full day",
  pricePerHead: "880 HKD pp",
  badge: "New Visitors",
  tags: "orientation, small, multi‑day, tour"
}, {
  index: "03",
  title: "Cheung Chau Island\xA0",
  description: "A car-free island escape 40 minutes from Central. Morning bun-making workshop with a local bakery family, afternoon split between kayaking or windsurfing and cycling the coastal path, ending with a seafood BBQ on the beach as the sun sets over the South China Sea. No phones required — just village life at its best.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/499cf694-9347-4595-98ab-ded22a50e78a.png",
  duration: "8 hrs",
  capacity: "8-40 pax",
  timeOfDay: "Full day including Ferry",
  pricePerHead: "From $1,200 HKD",
  badge: "Authentic",
  tags: "team building, medium, full‑day, culture",
  indexClassName: "flex flex-col rounded-xl bg-card p-6 shadow-sm transition-shadow hover:shadow-md border border-border relative"
}, {
  index: "04",
  title: "Shenzhen Tech Safari",
  description: "Cross the border into the world's fastest city. Experience autonomous taxis, drone delivery hubs, and the robotics showrooms. Visit to Huaqiangbei electronics market. Lunch at a Shenzhen rooftop with views of the skyline that didn't exist 20 years ago. Returns to HK by evening. Subject to Visa limitations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/flying-drone-in-modern-city-2026-03-17-17-12-09-utc-scaled.png",
  duration: "8 hrs",
  capacity: "1-5 pax",
  timeOfDay: "Full Day",
  pricePerHead: "Bespoke Pricing",
  badge: "New",
  tags: "innovation, small, full‑day, tech"
}, {
  index: "05",
  title: "Old Hong Kong\nFood & Culture Trail",
  description: "Guided street food walk through Sham Shui Po or Wan Chai - cha chaan teng, dai pai dong, hidden dai pai. Culture through the stomach.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/asian-women-friend-eating-street-food-while-travel-2026-03-24-22-28-58-utc-1-scaled.png",
  duration: "3-5 hrs",
  capacity: "10-150 pax",
  timeOfDay: "Any time",
  pricePerHead: "Custom Quote",
  badge: "Food",
  tags: "food tour, large, short, food"
}, {
  index: "06",
  title: "Tai Chi & Temple Morning",
  description: "Sunrise tai chi in Kowloon Park, Wong Tai Sin temple visit, dim sum breakfast. Perfect bleisure add-on for arriving delegates.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/senior-woman-practicing-tai-chi-in-the-park-2026-01-07-02-00-30-utc-scaled.png",
  duration: "3-4 hrs",
  capacity: "4-20 pax",
  timeOfDay: "Morning",
  pricePerHead: "From $600 HKD",
  badge: "Impactful",
  tags: "wellness, small, short, wellness"
}, {
  index: "07",
  title: "Dragon Boat Challenge",
  description: "A high-energy team building tradition. Learn the basics of paddling and rhythm from professional coaches before competing in a mini-regatta in Sai Kung. Focuses on synchronization and collective effort. One of Hong Kong's most iconic team formats, run properly.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/Gemini_Generated_Image_2n2hkh2n2hkh2n2h-scaled.png",
  duration: "8 hrs",
  capacity: "16-60 pax",
  timeOfDay: "Full Day",
  pricePerHead: "From $950 HKD",
  badge: "Active",
  tags: "team building, medium, full‑day, sports"
}, {
  index: "08",
  title: "From Fishing Village to Global Hub",
  description: "A walking and storytelling masterclass through HK's extraordinary economic transformation. From colonial trade post to manufacturing hub to Asia's financial capital — told through the streets, buildings, and people that shaped it. Ends with a private rooftop view over the skyline. Ideal for executive education, leadership offsites, and strategy retreats.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/MVIMG_20181230_203525-scaled.png",
  duration: "3-4 hrs",
  capacity: "5-30 pax",
  timeOfDay: "Anytime",
  pricePerHead: "From $780 HKD",
  badge: "Educational",
  tags: "learning, small, short, lecture"
}, {
  index: "09",
  title: "Lamma Island Seafood & Craft",
  description: "A relaxed island escape. Visit a traditional fishing village, explore local craft shops, and enjoy a world-class multi-course seafood banquet at a renowned waterfront restaurant. Perfect for rewarding teams.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/lamma_island_seafood.png",
  duration: "5-6 hrs",
  capacity: "10-100 pax",
  timeOfDay: "Afternoon / Evening",
  pricePerHead: "From $1,100 HKD",
  badge: "Outdoor",
  tags: "reward, medium, short, food"
}, {
  index: "10",
  title: "Hong Kong after dark",
  description: "Experience the neon-lit energy of the city at night. From the Temple Street Night Market to hidden speakeasies and panoramic rooftop bars, discover the vibrant nightlife that defines Hong Kong's global reputation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/hong_kong_after_dark.png",
  duration: "3-4 hrs",
  capacity: "4-20 pax",
  timeOfDay: "Evening",
  pricePerHead: "From $800 HKD",
  badge: "Nightlife",
  tags: "social, small, short, nightlife"
}, {
  index: "11",
  title: "Streets of Hong Kong & Milk Tea Workshop",
  description: "A deep dive into the local lifestyle. Explore the bustling street markets of Mong Kok followed by a hands-on workshop learning the art of brewing authentic Hong Kong-style silk stocking milk tea with a master.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/d7e9d8ba-fdef-4e2f-bbc9-97371ce39962.png",
  duration: "4 hrs",
  capacity: "6-15 pax",
  timeOfDay: "Afternoon",
  pricePerHead: "From $650 HKD",
  badge: "Local Life",
  tags: "cultural, small, short, workshop"
}, {
  index: "12",
  title: "Mahjong, Calligraphy & Cantonese Basics",
  description: "Master the essentials of Hong Kong heritage. Learn the strategy of Mahjong, the grace of Chinese calligraphy, and key Cantonese phrases to navigate the city like a local. A perfect cultural immersion for teams.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/mahjong_calligraphy_workshop.png",
  duration: "3-5 hrs",
  capacity: "8-30 pax",
  timeOfDay: "Morning / Afternoon",
  pricePerHead: "From $750 HKD",
  badge: "Heritage",
  tags: "cultural, small, short, learning"
}];
export default function ExpertiseEtSolutions() {
  return;
}